import React from "react";
import imgData_1 from "../../assets/img/outCompany/ipps_cer01.png";
import imgData_2 from "../../assets/img/outCompany/ipps_cer02.png";
import imgData_3 from "../../assets/img/outCompany/ipps_cer03.png";
import imgData_4 from "../../assets/img/outCompany/ipps_cer04.png";
import { useLanguage } from "../../i18n/LanguageContext";

const OurCompany = () => {
  const { t } = useLanguage();

  return (
    <div className="mt-[65px] lg:mt-[80px] min-h-screen pb-20 md:pb-0 bg-white">
      <div className="mx-auto h-full sm:max-w-3xl lg:max-w-screen-2xl 2xl:max-w-screen-2xl px-5 md:px-8">
        <div className="w-full text-center pt-16 pb-6">
          <p className="text-sm md:text-base font-semibold uppercase tracking-widest text-orange mb-3">
            {t("company.label")}
          </p>
          <h1 className="text-blue text-3xl md:text-4xl lg:text-5xl font-bold leading-tight max-w-3xl mx-auto">
            {t("company.title")}
          </h1>
          <div className="mt-4 mx-auto w-20 h-1 rounded-full bg-gradient-to-r from-orange to-pink" />
        </div>

        <div className="w-full max-w-4xl mx-auto text-base md:text-lg lg:text-xl text-darkBlue/70 leading-relaxed space-y-6 mt-6">
          <p className="indent-8">{t("company.p1")}</p>
          <p className="indent-8">{t("company.p2")}</p>
        </div>

        <div className="mt-14 mb-10">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            <div className="overflow-hidden rounded-2xl shadow-md shadow-blue/10 transition-all duration-300 hover:shadow-xl hover:shadow-blue/20 hover:-translate-y-1">
              <img
                src={imgData_1}
                alt="IPPS Certificate 1"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="overflow-hidden rounded-2xl shadow-md shadow-blue/10 transition-all duration-300 hover:shadow-xl hover:shadow-blue/20 hover:-translate-y-1">
              <img
                src={imgData_2}
                alt="IPPS Certificate 2"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="overflow-hidden rounded-2xl shadow-md shadow-blue/10 transition-all duration-300 hover:shadow-xl hover:shadow-blue/20 hover:-translate-y-1">
              <img
                src={imgData_3}
                alt="IPPS Certificate 3"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="overflow-hidden rounded-2xl shadow-md shadow-blue/10 transition-all duration-300 hover:shadow-xl hover:shadow-blue/20 hover:-translate-y-1">
              <img
                src={imgData_4}
                alt="IPPS Certificate 4"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurCompany;
